import React from 'react';

import {useTranslation} from 'hooks';
import {useLayoutStore} from 'store';

import {TourProvider, useTour} from '@reactour/tour';

const TourInner = () => {
    const {setIsOpen, setSteps} = useTour();
    const translate = useTranslation();
    const showTour = useLayoutStore((state) => state.showTour);
    const setShowTour = useLayoutStore((state) => state.setShowTour);

    React.useEffect(() => {
        if (!showTour) return;

        setSteps([
            {selector: '[data-tour="burger-menu"]', content: translate('board.menu.tour.step_menu', translate('board.menu.tour.title'))},
            {selector: '[data-tour="sheet-info"]', content: translate('board.menu.tour.step_sheet_info')},
            {selector: '[data-tour="tool-select"]', content: translate('board.menu.tour.step_select')},
            {selector: '[data-tour="tool-draw"]', content: translate('board.menu.tour.step_draw')},
            {selector: '[data-tour="tool-text"]', content: translate('board.menu.tour.step_text')},
            {selector: '[data-tour="tool-player"]', content: translate('board.menu.tour.step_player')},
            {selector: '[data-tour="tool-lineup"]', content: translate('board.menu.tour.step_lineup')},
            {selector: '[data-tour="tool-color"]', content: translate('board.menu.tour.step_color')},
            {selector: '[data-tour="tool-timeline"]', content: translate('board.menu.tour.step_timeline')},
            {selector: '[data-tour="save-button"]', content: translate('board.menu.tour.step_save')},
            {selector: '[data-tour="more-menu"]', content: translate('board.menu.tour.step_background')},
            {selector: 'body', content: translate('board.menu.tour.step_finish')},
        ]);
        setIsOpen(true);
        setShowTour(false);
    }, [showTour, setIsOpen, setSteps, setShowTour, translate]);

    return null;
};

const Tour = ({children}) => {
    return (
        <TourProvider
            steps={[]}
            styles={{
                popover: (base) => ({
                    ...base,
                    backgroundColor: '#1a1a1a',
                    color: '#fff',
                    borderRadius: 8,
                }),
                arrow: (base) => ({...base, color: '#fff'}),
                dot: (base, {current}) => ({
                    ...base,
                    backgroundColor: current ? '#e53935' : '#555',
                }),
                close: (base) => ({...base, color: '#fff'}),
                maskWrapper: (base) => ({
                    ...base,
                    zIndex: 1202,
                    color: 'rgba(0, 0, 0, 0.82)',
                }),
                maskArea: (base) => ({
                    ...base,
                    rx: 6,
                    fill: 'black',
                }),
                highlightedArea: (base, state) => ({
                    ...base,
                    x: state.x - 3,
                    y: state.y - 3,
                    width: state.width + 6,
                    height: state.height + 6,
                    display: 'block',
                    fill: 'transparent',
                    stroke: '#4cff80',
                    strokeWidth: 2,
                    strokeDasharray: '6 4',
                    rx: 6,
                }),
            }}
            showBadge={false}
            padding={{mask: 6}}
        >
            <TourInner/>
            {children}
        </TourProvider>
    );
};

export default Tour;
